import React from "react";
import PropTypes from "prop-types";
import { Link } from "gatsby";
import GatsbyImg from "gatsby-image";
import tw from "twin.macro";

const Post = tw(
  Link
)`bg-white flex flex-col md:flex-row py-4 md:p-4 my-4 rounded border border-gray-100 hover:shadow-md focus:shadow-md transition ease-in-out duration-300`;
const PostImg = tw(
  GatsbyImg
)`w-full h-24 md:h-auto md:w-48 -mr-4 md:mr-0 md:-ml-4 -my-4 rounded-t md:rounded-r-none md:rounded-l`;
const PostContent = tw.div`flex-1 pl-4`;
const PostTitle = tw.h2`text-lg font-bold my-1`;
const PostDate = tw.h4`mt-6 md:mt-0 text-sm text-gray-500`;
const PostSummary = tw.p`text-sm`;

const PostLink = ({ to, title, date, summary, imgSrc }) => (
  <Post to={to}>
    {imgSrc && <PostImg fluid={imgSrc} />}
    <PostContent>
      <PostDate>{date}</PostDate>
      <PostTitle>{title}</PostTitle>
      <PostSummary>{summary}</PostSummary>
    </PostContent>
  </Post>
);

PostLink.propTypes = {
  to: PropTypes.string,
  title: PropTypes.string,
  date: PropTypes.string,
  summary: PropTypes.string,
  imgSrc: PropTypes.object,
};

export default PostLink;
